import axios from "axios";

// Step 1: Request pre-signed URL with token
export const getPresignedUrlWithTokens = async (token, api) => {
    const { data } = await axios.post(
        api,
        {},
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return data; // returns { key, uploadURL }
};


// Step 1: Request pre-signed URL with token
export const getPresignedUrlWithToken = async (token, api) => {
    const { data } = await axios.post(
        api,
        {},
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return data; // returns { key, uploadURL }, key is the name of the file
};

// Step 1: Request pre-signed URL with token
export const getPresignedUrlsWithTokenWithLoad = async (token, uploaddata, api) => {
    const { data } = await axios.post(
        api,
        uploaddata,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return data; // returns { key, uploadURL }, key is the name of the file
};

export const getOnePresignedUrlWithoutTokenWithLoad = async (api, uploaddata) => {
    const { data } = await axios.post(
        api,
        uploaddata,
        { headers: { "Content-Type": "application/json" } }
    );
    return data; // returns { key, uploadURL }, key is the name of the file
};

export const getTwoPresignedUrlWithoutTokens = async (api, uploaddata) => {
    const { data } = await axios.post(
        api,
        uploaddata,
        { headers: { "Content-Type": "application/json" } }
    );
    return data; // returns { key, uploadURL }, key is the name of the file
};

// Step 2: Upload to S3
export const uploadToS3 = async (blob, uploadURL) => {
    if (!blob) {
        throw new Error("uploadToS3 error: blob is undefined");
    }

    await axios.put(uploadURL, blob, {
        headers: { "Content-Type": blob.type || "image/jpeg" },
    });
};

export const uploadToS3_withOctet = async (blob, uploadURL) => {
    if (!blob) {
        throw new Error("uploadToS3 error: blob is undefined");
    }
   
    await axios.put(uploadURL, blob, {
        headers: { 'Content-Type': 'application/octet-stream' }
    });
};

// Step 3: Notify backend
export const notifyBackendUpload = async (token, obj, api) => {
    const { data } = await axios.post(
        api,
        obj,
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data; // returns { message, loc }
};


// Step 3: Notify backend
export const notifyBackendUploadWithoutToken = async (obj, api) => {
    const { data } = await axios.post(api, obj);
    return data; // returns { message, loc }
};